import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Link} from "react-router-dom";
import {Button, Form} from "antd";
import {MaskedInput} from "antd-mask-input";
import {StyledCheckbox} from "../../components/StyledCheckbox";
import {
    loginAction,
    regPhoneAction,
    requestPhoneConfirmationAction,
    verifyPhoneConfirmationAction
} from "../../redux/actions/loginActions";
import store from "../../redux/store";
import moment from "moment";
import {UserType} from "../../utils/types";
import {useSelector} from "react-redux";

const Top = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 45px;
  @media screen and (max-width: 370px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }

  h1 {
    margin: 0 12px 0 0;

    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    display: flex;
    align-items: center;

    color: #311C1C;
  }

  a {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;

    display: flex;
    align-items: center;

    color: #5B77CB;
  }
`;

const StyledCreateProfilePage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 65px 18.75% 450px 18.75%;
  
  @media screen and (max-width: 1919px) {
    padding: 65px 20px 450px 20px;
  }

  .ant-form-item {
    margin: 0;
  }

  .askBlock {
    margin-top: 40px;

    .askAgain {
      font-weight: 500;
      font-size: 18px;
      line-height: 140%;
      text-decoration-line: underline;

      color: #5B77CB;
      cursor: not-allowed;

      &.available {
        cursor: pointer;
      }
    }

    .timer {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;


      color: #8A8A8A;
    }
  }

  .ant-form {
    .ant-input {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;


      height: auto;
      padding: 16px 10px;

      color: #000000;
    }

    label {
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;

      color: #8A8A8A;

      &.ant-checkbox-wrapper {
        font-weight: 400;
        font-size: 18px;
        line-height: 140%;

        color: #000000;
      }
    }
  }


  .ant-btn {
    font-weight: 500;
    font-size: 18px;
    line-height: 140%;
    border: none;
    padding: 17px 28px;
    height: auto;
    background: #5B77CB;
    border-radius: 4px;
    margin-top: 32px;
    margin-bottom: 24px;

    &:disabled {
      background: gray;
    }

    span {
      color: #FFFFFF;
    }
  }
`;


function CreateProfilePage({code = false}) {
    const waitingTime = 60;
    const [isCode, setIsCode] = useState<boolean>(code);

    const user: UserType = useSelector((state: any) => state.loginReducer.userData);

    const [rulesAccepted, setRulesAccepted] = useState<boolean>(false);
    const [foreignPC, setForeignPC] = useState<boolean>(false);

    const [time, setTime] = useState<number>(waitingTime)
    const [againAvailable, setAgainAvailable] = useState<boolean>(false);

    const [showNumberReg, setShowNumberReg] = useState<boolean>(false);
    const [regPhone, setRegPhone] = useState<string>("");
    
    const [checkId, setCheckId] = useState<string>("");
    const [callPhone, setCallPhone] = useState<string>("");

    const [formRef] = Form.useForm();

    useEffect(() => {
        setIsCode(code);
    }, [code])
    
    useEffect(() => {
        if (isCode) {
            setShowNumberReg(true);
            if (!user.PhoneApproved) {
                store.dispatch(requestPhoneConfirmationAction()).then((data: any) => {
                    if (data) {
                        setCheckId(data.check_id);
                        setCallPhone(data.call_phone);
                    }
                })
            }
        }
    }, [isCode, user.PhoneApproved])

    useEffect(() => {
        setTime(waitingTime);
    }, [againAvailable])

    useEffect(() => {
        let interval: any;
        if (!againAvailable && (isCode || showNumberReg)) {
            interval = setInterval(() => {
                setTime((time) => time - 1)
            }, 1000)
        }

        if (time === 0) {
            clearInterval(interval);
            setAgainAvailable(true);
        }


        return () => {
            if (interval)
                clearInterval(interval);
        }
    }, [time, isCode, showNumberReg, againAvailable])

    return (
        <StyledCreateProfilePage>

            {isCode ? <Top><h1>Подтверждение звонком</h1></Top> :
                <Top><h1>Создать профиль</h1> <Link to={"/profile/login"}>или войти</Link></Top>}

            {showNumberReg && <Form form={formRef} requiredMark={false} layout={"vertical"} onFinish={(fields) => {
                if (isCode) {
                    store.dispatch(verifyPhoneConfirmationAction(checkId))
                } else {
                    store.dispatch(loginAction({
                        login: regPhone,
                        password: checkId,
                        save: !foreignPC
                    }))
                }
            }}>
                <div style={{marginBottom: 24}}>
                    <p style={{fontSize: 18, lineHeight: '140%', color: '#000'}}>
                        Для {isCode ? "подтверждения" : "входа"} позвоните на номер <b>{callPhone}</b>.<br/>
                        Звонок бесплатный, отвечать не нужно.
                    </p>
                </div>
                
                <Form.Item className={"askBlock"}>
                    <span className={`askAgain ${againAvailable ? "available" : ""}`} onClick={() => {
                        if (againAvailable) {
                            setAgainAvailable(false);
                            if (isCode) {
                                store.dispatch(requestPhoneConfirmationAction()).then((data: any) => {
                                    if(data) {
                                        setCheckId(data.check_id);
                                        setCallPhone(data.call_phone);
                                    }
                                })
                            } else {
                                store.dispatch(regPhoneAction({
                                    phone: regPhone
                                })).then((data: any) => {
                                    if(data) {
                                        setCheckId(data.check_id);
                                        setCallPhone(data.call_phone);
                                    }
                                })
                            }
                        }
                    }}>Запросить номер повторно</span> {!againAvailable && <span
                    className={"timer"}>через {moment.utc(time * 1000).format("mm:ss")}</span>}
                </Form.Item>
                
                <Form.Item>
                    <Button htmlType={"submit"}>Я позвонил</Button>
                </Form.Item>
            </Form>}

            {!showNumberReg && <Form layout={"vertical"} requiredMark={false} onFinish={(fields) => {
                store.dispatch(regPhoneAction({
                    ...fields,
                    phone: `${fields.phoneZone}${fields.phoneNumber}`.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "")
                })).then((data: any) => {
                    if (data) {
                        setCheckId(data.check_id);
                        setCallPhone(data.call_phone);
                    }
                    setRegPhone(`${fields.phoneZone}${fields.phoneNumber}`.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", ""));
                    setShowNumberReg(true);
                })
            }}>
                <Form.Item label={"Контактный телефон:"}>
                    <Form.Item initialValue={'+7'} name={"phoneZone"}
                               rules={[
                                   {
                                       required: true,
                                       message: "Поле не может быть пустым!"
                                   },
                                   {
                                       validator: (_, value) => {
                                           if (value !== undefined && value.indexOf("_") !== -1) {
                                               return Promise.reject(new Error("Поле не может быть пустым!"))
                                           } else {
                                               return Promise.resolve()
                                           }
                                       }
                                   }]}
                               style={{display: 'inline-block', width: 70}}>
                        <MaskedInput mask={'+0[0][0]'}/>
                    </Form.Item>
                    <Form.Item initialValue={"(___) ___ __ __"} name={"phoneNumber"}
                               rules={[
                                   {
                                       required: true,
                                       message: "Поле не может быть пустым!"
                                   },
                                   {
                                       validator: (_, value) => {
                                           if (value !== undefined && value.indexOf("_") !== -1) {
                                               return Promise.reject(new Error("Поле должно быть заполнено полностью!"))
                                           } else {
                                               return Promise.resolve()
                                           }
                                       }
                                   }]}
                               style={{display: 'inline-block', width: 'calc(215px - 8px)', margin: '0 8px'}}>
                        <MaskedInput mask={'(000) 000 00 00'}/>
                    </Form.Item>
                </Form.Item>
                <Form.Item>
                    <Button disabled={!rulesAccepted} htmlType={"submit"}>Получить код</Button>
                </Form.Item>
                <Form.Item>
                    <StyledCheckbox checked={foreignPC} onChange={(e) => setForeignPC(e.target.checked)}>Чужой
                        компьютер</StyledCheckbox>
                </Form.Item>
                <Form.Item>
                    <StyledCheckbox checked={rulesAccepted} onChange={(e) => setRulesAccepted(e.target.checked)}>Согласен
                        с условиями использования интернет-магазина</StyledCheckbox>
                </Form.Item>
            </Form>}
        </StyledCreateProfilePage>
    );
}

export default CreateProfilePage;